import type { DepartureDateStore } from '@/infrastructure/departure-date/store'
import { departureDateStore } from '@/infrastructure/departure-date/store'
import { identity } from 'ramda'
import { useStore } from 'zustand'

export function useDepartureDateStore() {
  return useStore(departureDateStore, identity<DepartureDateStore>)
}
